module.exports = __webpack_public_path__ + "static/img/2.e92e35e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/2.png
// module id = LDW4
// module chunks = 0